import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { marketingService } from '../../services/marketingService';

export const useGetBonusGroup = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.marketing.bonus_groups],
    queryFn: () =>
      marketingService.bonusGroups().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data || null;
        }
        throw new Error('Fetch failed');
      }),
  });
};
